export const UPDATE_TERMS = '[Terms] Update terms';
export const CHECK_TERMS = '[Terms] Check terms';

export const UPDATE_AGREEMENT = '[Terms] Update agreement';
